export default __webpack_public_path__ + "static/media/misc-drawerA-1440w.590933e8.avif";